<template>
  <div class="grids">
    <naj-loader v-if="getGridConfigLoading"></naj-loader>
    <naj-data-table
      v-else-if="headers && headers.length"
      ref="selection"
      :headers="computedHeaders"
      :items="value"
      :disable-items-per-page="true"
      :title="title"
      :skip-casting-keys="skipCastingKeys || []"
    >
      <template v-slot:header>
        <div class="grid-actions">
          <naj-button
            v-if="addAction && !viewMode"
            outlined
            color="primary"
            @click="
              openFormModal({
                viewMode,
                submitButtonText: local.common.add,
              })
            "
          >
            {{ addAction.actionName || local.common.add }}
          </naj-button>
        </div>
      </template>
      <template slot-scope="{ item }">
        <naj-button
          v-if="editAction && !viewMode"
          class="action-button"
          type="button"
          size="small"
          outlined
          @click="selectEditItem(item)"
        >
          {{ editAction.actionName || local.common.update }}
        </naj-button>
        <naj-button
          v-if="viewAction"
          class="action-button"
          type="button"
          size="small"
          outlined
          @click="selectViewItem(item)"
        >
          {{ viewAction.actionName || local.common.view }}
        </naj-button>
        <naj-button
          v-if="deleteAction && !viewMode"
          class="action-button"
          type="button"
          color="error"
          size="small"
          outlined
          @click="removeItem(item)"
        >
          {{ deleteAction.actionName || local.common.remove }}
        </naj-button>
      </template>
    </naj-data-table>
    <dynamic-form-modal
      :modal-visibility="formModal.show"
      :view-mode="formModal.viewMode"
      :submit-button-text="formModal.submitButtonText"
      :title="gridConfig.formLabel"
      :fields="gridConfig.fields"
      :custom-component-name="gridConfig.customComponentName"
      :initial-form-model="gridConfig.initialFormModel"
      :form-model="selectedItem"
      :root-form-model="rootFormModel"
      :data-sources="dataSources"
      :validate-on-submit="true"
      :required-data="requiredData"
      @onClose="closeModal"
      @formSubmitted="formModalSubmitted"
    ></dynamic-form-modal>
    <!-- <dynamic-form-modal
      :modal-visibility="modal.show == 'dynamic-form-modal'"
      :fields="modal.fields"
      :submit-button-text="modal.submitButtonText"
      @onClose="closeModal"
      @formSubmitted="addItem"
    ></dynamic-form-modal> -->

    <naj-confirmation
      :show-modal="showRemovePopup"
      color="error"
      :title="local.common.removeConfirmation"
      :message="local.common.removeConfirmationMessage"
      :ok-btn-label="local.common.remove"
      @ok="removeConfirmed"
      @cancel="showRemovePopup = false"
    ></naj-confirmation>
    <naj-error-text
      v-if="errorMessage"
      :text="errorMessage"
    ></naj-error-text>
  </div>
</template>

<script>
import { modalPosition, actionType, httpMethod } from '@/helpers/enum';
import { executeString, uuidGenerator } from '@/helpers/utils';
import DynamicFormModal from './dynamic-form-modal';
import globalModuleAPIs from '@/modules/global/services/api';

export default {
  name: 'Grids',
  $_veeValidate: {
    name() {
      return this.title;
    },
    value() {
      return this.value;
    },
  },
  components: { DynamicFormModal },
  props: ['value', 'title', 'config', 'viewMode', 'errorMessage', 'rootFormModel', 'dataSources', 'requiredData'],
  data() {
    return {
      executeString,
      selectedRows: [],
      searchQuery: {},
      modalPosition,
      actionType,
      httpMethod,
      width: '1200',
      modal: {
        show: '',
        fields: null,
        submitButtonText: null,
        params: {},
      },
      formModal: {
        show: false,
        fields: null,
        viewMode: false,
        submitButtonText: null,
      },
      tableLoading: false,
      isAdvancedSearchExpanded: false,
      showRemovePopup: false,
      selectedItem: {},
      gridConfig: {},
      getGridConfigLoading: false,
    };
  },
  computed: {
    headers() {
      return this.gridConfig.headers;
    },
    skipCastingKeys() {
      return this.gridConfig.skipCastingKeys;
    },
    computedHeaders() {
      return [...this.headers, {
        text: ' ',
        value: 'action',
      }];
    },
    actions() {
      return this.gridConfig.actions;
    },
    addAction() {
      return this.actions && this.actions.find(action => action.actionType == actionType.addNew);
    },
    editAction() {
      return this.actions && this.actions.find(action => action.actionType == actionType.edit);
    },
    deleteAction() {
      return this.actions && this.actions.find(action => action.actionType == actionType.delete);
    },
    viewAction() {
      return this.actions && this.actions.find(action => action.actionType == actionType.view);
    },
    computedActions() {
      return this.actions.map(action => ({
        ...action,
        ...JSON.parse(action.properties),
      }));
    },
  },
  watch: {
    config: {
      deep: true,
      handler() { this.loadGridConfig(); },
    },
  },
  mounted() {
    this.loadGridConfig();
  },
  methods: {
    loadGridConfig() {
      if (this.config.headers && this.config.headers.length) {
        this.gridConfig = this.config;
        if (this.gridConfig.formId) {
          this.getGridConfigLoading = true;
          globalModuleAPIs.getDynamicForm(this.gridConfig.formId)
            .then((res) => {
              if (res.data.isCustom)
                this.gridConfig.customComponentName = res.data.customComponentName;
              else
                this.gridConfig.fields = res.data.fields;
            })
            .finally(() => {
              this.getGridConfigLoading = false;
            });
        }
      } else {
        this.getGridConfigLoading = true;
        globalModuleAPIs.getDynamicGrid(this.config.gridId)
          .then((res) => {
            this.gridConfig = res.data.configurations;
            globalModuleAPIs.getDynamicForm(this.gridConfig.formId)
              .then((res) => {
                if (res.data.isCustom)
                  this.gridConfig.customComponentName = res.data.customComponentName;
                else
                  this.gridConfig.fields = res.data.fields;
              })
              .finally(() => {
                this.getGridConfigLoading = false;
              });
          });
      }
    },
    openFormModal({ viewMode = false, submitButtonText }) {
      this.formModal = {
        ...this.formModal,
        submitButtonText,
        show: true,
        viewMode,
      };
    },
    openModal({ componentName, params, fields, submitButtonText }) {
      this.modal.show = componentName;
      this.modal.params = params || {};
      this.modal.fields = fields || [];
      this.modal.submitButtonText = submitButtonText;
    },
    closeModal() {
      this.modal.show = '';
      this.formModal.show = false;
      setTimeout(() => {
        this.formModal.viewMode = false;
        this.selectedItem = {};
        this.modal.params = {};
      }, 250);
    },
    addItem(item) {
      this.updateValues([...(this.value || []), {
        ...item,
        objectKey: uuidGenerator(),
      }]);
    },
    editItem(item) {
      this.updateValues(this.value.map(i => (i.objectKey == item.objectKey ? item : i)));
    },
    formModalSubmitted(item) {
      item.objectKey ? this.editItem(item) : this.addItem(item);
    },
    updateValues(value) {
      this.$emit('update:value', value);
    },
    selectViewItem(item) {
      this.selectedItem = item;
      this.openFormModal({ viewMode: true });
    },
    selectEditItem(item) {
      this.selectedItem = item;
      this.openFormModal({
        viewMode: this.viewMode,
        submitButtonText: this.local.common.save,
      });
    },
    removeItem(item) {
      this.selectedItem = item;
      this.showRemovePopup = true;
    },
    removeConfirmed() {
      this.updateValues(this.value.filter(item => item.objectKey != this.selectedItem.objectKey));
      this.selectedItem = {};
      this.showRemovePopup = false;
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .ivu-table-header th {
  background-color: #eee !important;
}
.layout-actions {
  position: absolute;
  top: 19px;
  left: 50px;
}
.grid-actions {
  display: inline-flex;
}
.action-button {
  margin-bottom: 7px;
}
.icon {
  margin-right: 15px;
}
.up {
  -webkit-transform: rotate(180deg);
  -moz-transform: rotate(180deg);
  -o-transform: rotate(180deg);
  transform: rotate(180deg);
  // -webkit-transition-duration: 1s;
  // -moz-transition-duration: 1s;
  // -o-transition-duration: 1s;
  // transition-duration: 1s;
}
.advanced-search-btn {
  font-size: 20px;
  line-height: 23px;
  font-weight: 400;
  color: #252733;
  cursor: pointer;
}
::v-deep .v-data-table-header {
  border-top: none !important;
}
::v-deep .v-data-table tbody tr:hover {
  background-color: #fcfcfc !important;
}
</style>
